export const translations = {
  en: {
    'nav.home': 'Home',
    'nav.ipmNews': 'IPM News',
    'nav.ipmAcademy': 'IPM Academy',
    'nav.myIpmNews': 'My IPM News',
    'nav.newProperties': 'New Properties',
    'nav.logIn': 'Log into my IPM',
    'nav.signUp': 'Sign Up',
    'nav.dashboard': 'Dashboard',
    'nav.settings': 'Settings',
    'nav.collection': 'Collection',
    'nav.logout': 'Logout',
    'nav.language': 'Language',
    'nav.currency': 'Currency',
    'nav.units': 'Units',
    'nav.preferences': 'Preferences',
    'common.price': 'Price',
    'common.area': 'Area',
    'common.sqft': 'sqft',
    'common.sqm': 'm²',
    'common.beds': 'Beds',
    'common.baths': 'Baths',
    'common.forSale': 'For Sale',
    'hero.search': 'Search by location, property type...',
    'hero.find': 'Find your perfect property',
    'collection.matchScore': 'Match Score',
    'collection.priceLow': 'Price: Low',
    'collection.priceHigh': 'Price: High',
    'collection.maxPrice': 'Max Price',
    'collection.all': 'All',
    'saved.savedListings': 'Saved Listings',
    'saved.title': 'Saved Collection',
    'saved.subtitle': 'Manage your shortlisted opportunities',
    'property.estMonthly': 'EST. MONTHLY',
    'property.bedsBaths': 'Beds, Baths',
    'property.price': 'Price',
    'property.area': 'Property Area',
    'footer.rights': 'All rights reserved.',
    'hero.titleLine1': 'Redefined standard for',
    'hero.titleLine2': 'intelligence-driven real estate',
    'hero.landingTitle1': 'The Real Estate Market,',
    'hero.landingTitle2': 'Reinvented.',
    'hero.landingTagline': 'One platform for agents, buyers, investors, and industry experts - global reach, real data, seamless collaboration.',
    'hero.searchCta': 'Search',
    'hero.tabAgents': 'Agents',
    'hero.tabBuy': 'Buy',
    'hero.tabRent': 'Rent',
    'hero.tabInvest': 'Invest',
    'hero.tabPartner': 'Industry Expert',
    'hero.tabEnterprise': 'Enterprise',
    'hero.promptAgents': 'Example: Off-market villas my clients would love in Marbella or Dubai…',
    'hero.promptBuy': 'Example: 3-bed family home near good schools, under €800k in Lisbon…',
    'hero.promptRent': 'Example: Furnished 2-bed near metro, long lease, max €2,500/mo…',
    'hero.promptInvest': 'Example: Stable rental yield 7%+, Europe or UAE, €500k ticket…',
    'hero.promptPartner': 'Example: Co-listing luxury waterfront with verified international buyers…',
    'hero.promptEnterprise': 'Example: Scale my agency across multiple markets from one platform…',
    'hero.numbersStripAria': 'Platform metrics',
    'hero.numbersSegmentLabel': 'Client Segments Served',
    'hero.numbersSolutionsLabel': 'Platform Solutions',
    'hero.numbersMarketsLabel': 'Global Markets',
    'hero.numbersAllValue': 'All',
    'journeyStrip.aria': 'Property journey stages',
    'journeyStrip.eyebrow': 'One Subscription · The Entire Property Journey',
    'journeyStrip.headingLead': 'Every stage. Every stakeholder.',
    'journeyStrip.headingAccent': 'One platform.',
    'journeyStrip.step1Title': 'Property Discovery',
    'journeyStrip.step1Desc': 'Find opportunities across markets with intelligent precision',
    'journeyStrip.step2Title': 'Market Intelligence',
    'journeyStrip.step2Desc': 'Assess value, demand and growth with real data',
    'journeyStrip.step3Title': 'Opportunity Matching',
    'journeyStrip.step3Desc': 'Connect the right buyer, investor or agent',
    'journeyStrip.step4Title': 'Deal Collaboration',
    'journeyStrip.step4Desc': 'All parties in one shared workspace',
    'journeyStrip.step5Title': 'Property Management',
    'journeyStrip.step5Desc': 'Listings, assets and docs in one platform',
    'journeyStrip.step6Title': 'Portfolio Insights',
    'journeyStrip.step6Desc': 'Track performance and long-term value',
    'welcomeSection.aria': 'Welcome to IPM',
    'welcomeSection.eyebrow': 'Welcome to IPM',
    'welcomeSection.headingLead': 'A Historic Standard,',
    'welcomeSection.headingAccent': 'Reinvented.',
    'welcomeSection.body1': 'Pairing the precision of data with the personal experience of the real estate industry, IPM invites you into a connected, intelligent and globally accessible property experience.',
    'welcomeSection.body2': 'Founded by experienced real estate leaders, IPM was intentionally designed as an integrated ecosystem, connecting insight, collaboration and global reach in one platform.',
    'welcomeSection.ctaExplore': 'Explore the Platform',
    'welcomeSection.ctaPricing': 'View Pricing',
    'darkFeatureSection.aria': 'IPM investor solutions and platform overview',
    'darkFeatureSection.investorTitle': 'IPM Investor',
    'darkFeatureSection.investorAccent': 'Solutions',
    'darkFeatureSection.searchPlaceholder': 'Describe your ideal next investment',
    'darkFeatureSection.rentalYieldTitle': 'Rental Yield',
    'darkFeatureSection.rentalYieldSub': 'Annual Yield Estimate',
    'darkFeatureSection.rentalYieldBadge': 'Above market avg.',
    'darkFeatureSection.domTitle': 'Days on Market',
    'darkFeatureSection.domSub': 'Average days before sale',
    'darkFeatureSection.domBadge': 'Fast-moving area',
    'darkFeatureSection.energyTitle': 'Energy Rating',
    'darkFeatureSection.energySub': 'Building energy performance',
    'darkFeatureSection.energyBadge': 'Top-tier performance',
    'darkFeatureSection.confidenceTitle': 'Investment Confidence',
    'darkFeatureSection.confidenceSub': 'Composite signal score from market, rental & location data.',
    'darkFeatureSection.confidenceScore': 'Confidence Score',
    'darkFeatureSection.feat1Title': 'Strong Expat Demand',
    'darkFeatureSection.feat1Desc': 'Dubai Hills popular with high-income expats & remote workers.',
    'darkFeatureSection.feat2Title': 'Premium New Build',
    'darkFeatureSection.feat2Desc': '2023 completion - no maintenance backlog, modern ESG spec.',
    'darkFeatureSection.feat3Title': 'Consistent Appreciation',
    'darkFeatureSection.feat3Desc': '+18% over 5 years with ongoing infrastructure investment.',
    'darkFeatureSection.futureTitle': 'Future Prospects',
    'darkFeatureSection.futureSub': 'In Your Area',
    'darkFeatureSection.propertyBlurb': 'Contemporary, modern property with all of the premium features that fit your portfolio.',
    'darkFeatureSection.viewNow': 'View Now',
    'darkFeatureSection.ipmScore': 'IPM Score',
    'darkFeatureSection.pvScore': 'PV Score',
    'darkFeatureSection.scoreOutOf': '/ 100',
    'darkFeatureSection.barLeftAmount': '€28,800',
    'darkFeatureSection.barRightAmount': '€16,700',
    'darkFeatureSection.totalReturn': 'Total Return',
    'darkFeatureSection.annualizedYtd': 'Annualized (YTD)',
    'darkFeatureSection.returnGain': 'Total estimated gain: €24,500',
    'darkFeatureSection.capGrowth': 'Capital Growth',
    'darkFeatureSection.netRental': 'Net Rental Yield',
    'darkFeatureSection.trajectory': 'Annualized trajectory & Yield growth',
    'darkFeatureSection.months12': '12 Months',
    'darkFeatureSection.eyebrow': 'An IPM Exclusive',
    'darkFeatureSection.heading': 'One Subscription. The entire property journey.',
    'darkFeatureSection.headingLine1': 'One Subscription.',
    'darkFeatureSection.headingLine2': 'The entire property journey.',
    'darkFeatureSection.lead': 'IPM serves every stakeholder in the property lifecycle - from agents and agencies winning more mandates, to buyers finding the right property with AI-powered clarity, investors modelling real-time yield, and enterprise partners scaling across global markets.',
    'darkFeatureSection.audience1Title': 'Agents & Agencies',
    'darkFeatureSection.audience1Body': 'Prospect smarter, list faster and close with confidence. AI-powered lead scoring, €0 lead cost, CMA Builder, virtual staging and a full CRM - everything to win mandates and grow your real estate business successfully.',
    'darkFeatureSection.audience2Title': 'Buyers, Renters & Investors',
    'darkFeatureSection.audience2Body': 'Find the right property with natural language search and an IPM Score on every result. Model rental yield, analyse market data and close confidently with Smart Vault AI reviewing every clause.',
    'darkFeatureSection.audience3Title': 'Enterprise Partners & Corporates',
    'darkFeatureSection.audience3Body': 'Connect your agency franchise, corporate portfolio or referral network to the IPM ecosystem. White-label tools, deal collaboration workspaces, global reach and enterprise analytics in one place.',
    'darkFeatureSection.audience1ServicesCta': 'Explore agent & agency tools →',
    'darkFeatureSection.audience2ServicesCta': 'Explore buyer & renter tools →',
    'darkFeatureSection.audience3ServicesCta': 'Explore enterprise & partner solutions →',
    'darkFeatureSection.ctaPlatform': 'Explore Full Platform',
    'darkFeatureSection.ctaPricing': 'View Pricing',
    'serviceCardsSection.eyebrow': "WHO IT'S FOR",
    'serviceCardsSection.headingLine1': 'Your Property Journey',
    'serviceCardsSection.headingLine2': 'is Calling.',
    'serviceCardsSection.cta': 'View full services →',
    'hero.placeholder': 'Describe your ideal property...',
    'hero.feature1': 'Hyper Personalized AI Tailored For You',
    'hero.feature2': 'Market Analytics & Live News',
    'hero.feature3': 'One Platform For All Stakeholders',
    'hero.stats1': 'Of Tasks Automated For Agents',
    'hero.stats2': 'Improvement In Property Research',
    'hero.stats3': 'Projected Returns On Capital Improvements',
    'hero.slideBuyers': 'Buyers',
    'hero.slideInvestors': 'Investors',
    'hero.slideSellers': 'Agencies',
    'footer.getInTouch': 'Get in touch',
    'footer.intro': 'Have questions? Pick a date below to schedule a call.',
    'footer.firstName': 'First Name',
    'footer.lastName': 'Last Name',
    'footer.email': 'E-mail',
    'footer.phone': 'Phone',
    'footer.helpPlaceholder': 'What can we help you with?',
    'footer.submit': 'Submit',
    'common.loading': 'Loading...',
    'common.view': 'View',
    'common.viewProperty': 'View property',
    'common.address': 'Address',
    'common.location': 'Location',
    'common.any': 'Any',
    'common.bedrooms': 'Bedrooms',
    'common.resetAll': 'Reset All',
    'common.clearFilters': 'Clear Filters',
    'common.pleaseLogin': 'Please login to save.',
    'collection.resultsFor': 'Results for',
    'collection.bestMatches': 'We\'ve found the best matches just for you!',
    'collection.hideFilters': 'Hide Filters',
    'collection.specifyFilters': 'Specify more filters',
    'collection.sortBy': 'Sort by',
    'collection.locations': 'Locations',
    'collection.noPropertiesFound': 'No properties found.',
    'collection.matchScoreLabel': 'Match Score',
    'saved.viewDetails': 'View Details',
    'saved.noSavedYet': 'No saved properties yet',
    'saved.browseCollection': 'Browse Collection',
    'saved.comingSoon': 'View and manage all your Saved properties on one easy place',
    'saved.allTypes': 'All Types',
    'login.welcomeBack': 'Welcome Back.',
    'login.welcomeSub': 'Your portfolio performance, analytics, and global market trends are waiting.',
    'login.backToHome': 'Back to Home',
    'login.logIn': 'Log In',
    'login.enterCredentials': 'Enter your credentials to access your dashboard.',
    'login.emailAddress': 'Email Address',
    'login.password': 'Password',
    'login.forgot': 'Forgot?',
    'login.authenticating': 'Authenticating...',
    'login.newToIpm': 'New to IPM?',
    'login.createAccount': 'Create an account',
    'sidebar.myDashboard': 'My Dashboard',
    'sidebar.myPortfolio': 'My Portfolio',
    'sidebar.savedProperties': 'Saved Properties',
    'sidebar.listingManagement': 'Listing Management',
    'sidebar.agents': 'Agents',
    'sidebar.myVault': 'My Vault',
    'sidebar.settings': 'Settings',
    'sidebar.addListing': 'Add Listing',
    'newDev.title': 'New Developments',
    'newDev.filterBy': 'Filter by',
    'newDev.country': 'Country',
    'newDev.viewDevelopment': 'View Development',
    'newDev.from': 'From',
    'newDev.estimatedYield': 'Estimated yield',
    'newDev.noDevelopments': 'No developments found in',
    'listing.view': 'Preview',
    'listing.edit': 'Edit',
    'listing.delete': 'Delete',
    'listing.priceActions': 'Price + Actions',
    'listing.available': 'Available',
    'listing.featured': 'Featured',
    'listing.sold': 'Sold',
    'listing.noListings': "You haven't added any properties yet.",
    'sidebar.crm': 'CRM',
    'sidebar.marketing': 'Marketing',
    'sidebar.askAi': 'ASK IPM AI',
    'about.title': 'About IPM',
    'about.mission': 'Our Mission',
    'contact.getInTouch': 'Get in touch',
    'contact.formIntro': 'Fill out the form and our team will get back to you within 24 hours.',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.message': 'Message',
    'contact.sendMessage': 'Send Message',
    'news.loading': 'Loading Articles...',
    'news.latestPosts': 'Latest Posts',
    'news.sortBy': 'Sort by',
    'news.minRead': 'Min read',
    'newsDetail.loading': 'Loading Article...',
    'newsDetail.notFound': 'Article not found.',
    'newsDetail.backToNews': '← Back to News',
  },
  es: {
    'nav.home': 'Inicio',
    'nav.ipmNews': 'Noticias IPM',
    'nav.ipmAcademy': 'Academia IPM',
    'nav.myIpmNews': 'Mis Noticias IPM',
    'nav.newProperties': 'Nuevas Propiedades',
    'nav.logIn': 'Iniciar sesión en mi IPM',
    'nav.signUp': 'Registrarse',
    'nav.dashboard': 'Panel',
    'nav.settings': 'Ajustes',
    'nav.collection': 'Colección',
    'nav.logout': 'Cerrar sesión',
    'nav.language': 'Idioma',
    'nav.currency': 'Moneda',
    'nav.units': 'Unidades',
    'nav.preferences': 'Preferencias',
    'common.price': 'Precio',
    'common.area': 'Superficie',
    'common.sqft': 'pies²',
    'common.sqm': 'm²',
    'common.beds': 'Hab',
    'common.baths': 'Baños',
    'common.forSale': 'En venta',
    'hero.search': 'Buscar por ubicación, tipo de propiedad...',
    'hero.find': 'Encuentra tu propiedad ideal',
    'collection.matchScore': 'Puntuación',
    'collection.priceLow': 'Precio: Bajo',
    'collection.priceHigh': 'Precio: Alto',
    'collection.maxPrice': 'Precio máx.',
    'collection.all': 'Todos',
    'saved.savedListings': 'Guardados',
    'saved.title': 'Colección guardada',
    'saved.subtitle': 'Gestiona tus oportunidades guardadas',
    'property.estMonthly': 'EST. MENSUAL',
    'property.bedsBaths': 'Hab, Baños',
    'property.price': 'Precio',
    'property.area': 'Superficie',
    'footer.rights': 'Todos los derechos reservados.',
    'hero.titleLine1': 'Nuevo estándar en',
    'hero.titleLine2': 'bienes raíces inteligentes',
    'hero.landingTitle1': 'El mercado inmobiliario,',
    'hero.landingTitle2': 'reinventado.',
    'hero.landingTagline': 'Una plataforma para agentes, compradores, inversores y socios: alcance global, datos reales y colaboración fluida.',
    'hero.searchCta': 'Buscar',
    'hero.tabAgents': 'Agentes',
    'hero.tabBuy': 'Comprar',
    'hero.tabRent': 'Alquilar',
    'hero.tabInvest': 'Invertir',
    'hero.tabPartner': 'Socio',
    'hero.tabEnterprise': 'Empresa',
    'hero.promptAgents': 'Ej.: Villas fuera de mercado que encantarían a mis clientes en Marbella o Dubái…',
    'hero.promptBuy': 'Ej.: Casa 3 hab. cerca de colegios, menos de 800k € en Lisboa…',
    'hero.promptRent': 'Ej.: 2 hab. amueblado cerca del metro, alquiler largo, máx. 2500 $/mes…',
    'hero.promptInvest': 'Ej.: Rentabilidad estable 7%+, Europa o EAU, ticket 500k €…',
    'hero.promptPartner': 'Ej.: Co-listing de lujo frente al mar con compradores internacionales…',
    'hero.promptEnterprise': 'Ej.: Despliegue para nuestra red de agencias en APAC y MENA…',
    'hero.numbersStripAria': 'Métricas de la plataforma',
    'hero.numbersSegmentLabel': 'Segmentos de clientes atendidos',
    'hero.numbersSolutionsLabel': 'Soluciones de la plataforma',
    'hero.numbersMarketsLabel': 'Mercados globales',
    'hero.numbersAllValue': 'Todos',
    'journeyStrip.aria': 'Etapas del recorrido inmobiliario',
    'journeyStrip.eyebrow': 'Una suscripción · Todo el recorrido del inmueble',
    'journeyStrip.headingLead': 'Cada etapa. Cada actor.',
    'journeyStrip.headingAccent': 'Una plataforma.',
    'journeyStrip.step1Title': 'Descubrimiento',
    'journeyStrip.step1Desc': 'Encuentra oportunidades en todos los mercados con precisión inteligente',
    'journeyStrip.step2Title': 'Inteligencia de mercado',
    'journeyStrip.step2Desc': 'Evalúa valor, demanda y crecimiento con datos reales',
    'journeyStrip.step3Title': 'Matching de oportunidades',
    'journeyStrip.step3Desc': 'Conecta al comprador, inversor o agente adecuado',
    'journeyStrip.step4Title': 'Colaboración en el negocio',
    'journeyStrip.step4Desc': 'Todas las partes en un espacio compartido',
    'journeyStrip.step5Title': 'Gestión de activos',
    'journeyStrip.step5Desc': 'Anuncios, activos y documentos en una sola plataforma',
    'journeyStrip.step6Title': 'Visión de cartera',
    'journeyStrip.step6Desc': 'Sigue el rendimiento y el valor a largo plazo',
    'welcomeSection.aria': 'Bienvenido a IPM',
    'welcomeSection.eyebrow': 'Bienvenido a IPM',
    'welcomeSection.headingLead': 'Un estándar histórico,',
    'welcomeSection.headingAccent': 'reinventado.',
    'welcomeSection.body1': 'Combinando la precisión de los datos con la experiencia personal del sector inmobiliario, IPM te invita a una experiencia conectada, inteligente y accesible a nivel global.',
    'welcomeSection.body2': 'Fundada por líderes inmobiliarios con experiencia, IPM se diseñó como un ecosistema integrado que une insights, colaboración y alcance global en una sola plataforma.',
    'welcomeSection.ctaExplore': 'Explorar la plataforma',
    'welcomeSection.ctaPricing': 'Ver precios',
    'darkFeatureSection.aria': 'Soluciones para inversores y visión de la plataforma IPM',
    'darkFeatureSection.investorTitle': 'IPM Investor',
    'darkFeatureSection.investorAccent': 'Solutions',
    'darkFeatureSection.searchPlaceholder': 'Describe tu próxima inversión ideal',
    'darkFeatureSection.rentalYieldTitle': 'Rendimiento por alquiler',
    'darkFeatureSection.rentalYieldSub': 'Estimación de rentabilidad anual',
    'darkFeatureSection.rentalYieldBadge': 'Por encima del mercado',
    'darkFeatureSection.domTitle': 'Días en el mercado',
    'darkFeatureSection.domSub': 'Días medios hasta la venta',
    'darkFeatureSection.domBadge': 'Zona de alta rotación',
    'darkFeatureSection.energyTitle': 'Calificación energética',
    'darkFeatureSection.energySub': 'Rendimiento energético del edificio',
    'darkFeatureSection.energyBadge': 'Rendimiento de primer nivel',
    'darkFeatureSection.confidenceTitle': 'Confianza en la inversión',
    'darkFeatureSection.confidenceSub': 'Puntuación compuesta a partir de mercado, alquiler y ubicación.',
    'darkFeatureSection.confidenceScore': 'Puntuación de confianza',
    'darkFeatureSection.feat1Title': 'Fuerte demanda expatriada',
    'darkFeatureSection.feat1Desc': 'Dubai Hills, popular entre expatriados de altos ingresos y teletrabajadores.',
    'darkFeatureSection.feat2Title': 'Obra nueva premium',
    'darkFeatureSection.feat2Desc': 'Entrega 2023 - sin rezagos de mantenimiento, especificación ESG moderna.',
    'darkFeatureSection.feat3Title': 'Revalorización constante',
    'darkFeatureSection.feat3Desc': '+18% en 5 años con inversión continua en infraestructura.',
    'darkFeatureSection.futureTitle': 'Perspectivas futuras',
    'darkFeatureSection.futureSub': 'En tu zona',
    'darkFeatureSection.propertyBlurb': 'Propiedad contemporánea con prestaciones premium que encajan en tu cartera.',
    'darkFeatureSection.viewNow': 'Ver ahora',
    'darkFeatureSection.ipmScore': 'IPM Score',
    'darkFeatureSection.pvScore': 'PV Score',
    'darkFeatureSection.scoreOutOf': '/ 100',
    'darkFeatureSection.barLeftAmount': '€28.800',
    'darkFeatureSection.barRightAmount': '€16.700',
    'darkFeatureSection.totalReturn': 'Rentabilidad total',
    'darkFeatureSection.annualizedYtd': 'Anualizado (YTD)',
    'darkFeatureSection.returnGain': 'Ganancia estimada total: €24.500',
    'darkFeatureSection.capGrowth': 'Crecimiento de capital',
    'darkFeatureSection.netRental': 'Rendimiento neto por alquiler',
    'darkFeatureSection.trajectory': 'Trayectoria anualizada y crecimiento del yield',
    'darkFeatureSection.months12': '12 meses',
    'darkFeatureSection.eyebrow': 'Exclusivo IPM',
    'darkFeatureSection.heading': 'Una suscripción. Todo el recorrido inmobiliario.',
    'darkFeatureSection.headingLine1': 'Una suscripción.',
    'darkFeatureSection.headingLine2': 'Todo el recorrido inmobiliario.',
    'darkFeatureSection.lead': 'IPM atiende a todos los actores del ciclo inmobiliario: agentes y agencias que ganan más mandatos, compradores que encuentran el inmueble adecuado con claridad impulsada por IA, inversores que modelan rentabilidad en tiempo real y socios enterprise que escalan en mercados globales.',
    'darkFeatureSection.audience1Title': 'Agentes y agencias',
    'darkFeatureSection.audience1Body': 'Prospecciona con más inteligencia, publica más rápido y cierra con confianza. Lead scoring con IA, coste de lead €0, CMA Builder, staging virtual y CRM completo - todo para ganar mandatos y hacer crecer tu negocio.',
    'darkFeatureSection.audience2Title': 'Compradores, inquilinos e inversores',
    'darkFeatureSection.audience2Body': 'Encuentra el inmueble adecuado con búsqueda en lenguaje natural y IPM Score en cada resultado. Modela rentabilidad, analiza el mercado y cierra con seguridad gracias a Smart Vault AI revisando cada cláusula.',
    'darkFeatureSection.audience3Title': 'Socios enterprise y corporativos',
    'darkFeatureSection.audience3Body': 'Conecta tu franquicia, cartera corporativa o red de referidos al ecosistema IPM. Herramientas white-label, espacios de colaboración en operaciones, alcance global y analítica enterprise en un solo lugar.',
    'darkFeatureSection.audience1ServicesCta': 'Explorar herramientas para agentes y agencias →',
    'darkFeatureSection.audience2ServicesCta': 'Explorar herramientas para compradores e inquilinos →',
    'darkFeatureSection.audience3ServicesCta': 'Explorar soluciones enterprise y socios →',
    'darkFeatureSection.ctaPlatform': 'Explorar la plataforma completa',
    'darkFeatureSection.ctaPricing': 'Ver precios',
    'serviceCardsSection.eyebrow': 'PARA QUIÉN ES',
    'serviceCardsSection.headingLine1': 'Tu recorrido inmobiliario',
    'serviceCardsSection.headingLine2': 'te está llamando.',
    'serviceCardsSection.cta': 'Ver todos los servicios →',
    'hero.placeholder': 'Describe tu propiedad ideal...',
    'hero.feature1': 'IA hiper personalizada para ti',
    'hero.feature2': 'Análisis de mercado y noticias en vivo',
    'hero.feature3': 'Una plataforma para todos',
    'hero.stats1': 'Tareas automatizadas para agentes',
    'hero.stats2': 'Mejora en investigación de propiedades',
    'hero.stats3': 'Retornos proyectados en mejoras',
    'hero.slideBuyers': 'Compradores',
    'hero.slideInvestors': 'Inversores',
    'hero.slideSellers': 'Agencias',
    'footer.getInTouch': 'Contáctanos',
    'footer.intro': '¿Tienes preguntas? Elige una fecha para agendar una llamada.',
    'footer.firstName': 'Nombre',
    'footer.lastName': 'Apellido',
    'footer.email': 'Correo',
    'footer.phone': 'Teléfono',
    'footer.helpPlaceholder': '¿En qué podemos ayudarte?',
    'footer.submit': 'Enviar',
    'common.loading': 'Cargando...',
    'common.view': 'Ver',
    'common.viewProperty': 'Ver propiedad',
    'common.address': 'Dirección',
    'common.location': 'Ubicación',
    'common.any': 'Cualquiera',
    'common.bedrooms': 'Habitaciones',
    'common.resetAll': 'Restablecer',
    'common.clearFilters': 'Limpiar filtros',
    'common.pleaseLogin': 'Inicia sesión para guardar.',
    'collection.resultsFor': 'Resultados para',
    'collection.bestMatches': '¡Encontramos las mejores opciones para ti!',
    'collection.hideFilters': 'Ocultar filtros',
    'collection.specifyFilters': 'Más filtros',
    'collection.sortBy': 'Ordenar por',
    'collection.locations': 'Ubicaciones',
    'collection.noPropertiesFound': 'No se encontraron propiedades.',
    'collection.matchScoreLabel': 'Puntuación',
    'saved.viewDetails': 'Ver detalles',
    'saved.noSavedYet': 'Aún no hay propiedades guardadas',
    'saved.browseCollection': 'Explorar colección',
    'saved.comingSoon': 'Ver y gestionar tus propiedades guardadas en un solo lugar.',
    'saved.allTypes': 'Todos los tipos',
    'login.welcomeBack': 'Bienvenido de nuevo.',
    'login.welcomeSub': 'Tu rendimiento, análisis y tendencias del mercado te esperan.',
    'login.backToHome': 'Volver al inicio',
    'login.logIn': 'Iniciar sesión',
    'login.enterCredentials': 'Introduce tus datos para acceder al panel.',
    'login.emailAddress': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.forgot': '¿Olvidaste?',
    'login.authenticating': 'Autenticando...',
    'login.newToIpm': '¿Nuevo en IPM?',
    'login.createAccount': 'Crear cuenta',
    'sidebar.myDashboard': 'Mi panel',
    'sidebar.myPortfolio': 'Mi cartera',
    'sidebar.savedProperties': 'Propiedades guardadas',
    'sidebar.listingManagement': 'Gestión de listados',
    'sidebar.agents': 'Agentes',
    'sidebar.myVault': 'Mi bóveda',
    'sidebar.settings': 'Ajustes',
    'sidebar.addListing': 'Añadir listado',
    'newDev.title': 'Nuevos desarrollos',
    'newDev.filterBy': 'Filtrar por',
    'newDev.country': 'País',
    'newDev.viewDevelopment': 'Ver desarrollo',
    'newDev.from': 'Desde',
    'newDev.estimatedYield': 'Rendimiento estimado',
    'newDev.noDevelopments': 'No hay desarrollos en',
    'listing.view': 'Vista previa',
    'listing.edit': 'Editar',
    'listing.delete': 'Eliminar',
    'listing.priceActions': 'Precio + Acciones',
    'listing.available': 'Disponible',
    'listing.featured': 'Destacado',
    'listing.sold': 'Vendido',
    'listing.noListings': 'Aún no has añadido ninguna propiedad.',
    'sidebar.crm': 'CRM',
    'sidebar.marketing': 'Marketing',
    'sidebar.askAi': 'Preguntar a IPM IA',
    'about.title': 'Sobre IPM',
    'about.mission': 'Nuestra misión',
    'contact.getInTouch': 'Contáctanos',
    'contact.formIntro': 'Completa el formulario y nuestro equipo te responderá en 24 horas.',
    'contact.name': 'Nombre',
    'contact.email': 'Correo electrónico',
    'contact.message': 'Mensaje',
    'contact.sendMessage': 'Enviar mensaje',
    'news.loading': 'Cargando artículos...',
    'news.latestPosts': 'Últimas publicaciones',
    'news.sortBy': 'Ordenar por',
    'news.minRead': 'min de lectura',
    'newsDetail.loading': 'Cargando artículo...',
    'newsDetail.notFound': 'Artículo no encontrado.',
    'newsDetail.backToNews': '← Volver a Noticias',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.ipmNews': 'Actualités IPM',
    'nav.ipmAcademy': 'Académie IPM',
    'nav.myIpmNews': 'Mes actualités IPM',
    'nav.newProperties': 'Nouvelles propriétés',
    'nav.logIn': 'Se connecter à mon IPM',
    'nav.signUp': "S'inscrire",
    'nav.dashboard': 'Tableau de bord',
    'nav.settings': 'Paramètres',
    'nav.collection': 'Collection',
    'nav.logout': 'Déconnexion',
    'nav.language': 'Langue',
    'nav.currency': 'Devise',
    'nav.units': 'Unités',
    'nav.preferences': 'Préférences',
    'common.price': 'Prix',
    'common.area': 'Surface',
    'common.sqft': 'pieds²',
    'common.sqm': 'm²',
    'common.beds': 'Chambres',
    'common.baths': 'Salles de bain',
    'common.forSale': 'À vendre',
    'hero.search': 'Rechercher par lieu, type de bien...',
    'hero.find': 'Trouvez la propriété idéale',
    'collection.matchScore': 'Score',
    'collection.priceLow': 'Prix : Bas',
    'collection.priceHigh': 'Prix : Élevé',
    'collection.maxPrice': 'Prix max',
    'collection.all': 'Tous',
    'saved.savedListings': 'Favoris',
    'saved.title': 'Collection enregistrée',
    'saved.subtitle': 'Gérez vos opportunités enregistrées',
    'property.estMonthly': 'EST. MENSUEL',
    'property.bedsBaths': 'Ch., Sdb',
    'property.price': 'Prix',
    'property.area': 'Surface',
    'footer.rights': 'Tous droits réservés.',
    'hero.titleLine1': 'Nouvelle référence pour',
    'hero.titleLine2': 'l\'immobilier intelligent',
    'hero.landingTitle1': 'Le marché immobilier,',
    'hero.landingTitle2': 'réinventé.',
    'hero.landingTagline': 'Une plateforme pour agents, acheteurs, investisseurs et partenaires - portée mondiale, données réelles, collaboration fluide.',
    'hero.searchCta': 'Rechercher',
    'hero.tabAgents': 'Agents',
    'hero.tabBuy': 'Acheter',
    'hero.tabRent': 'Louer',
    'hero.tabInvest': 'Investir',
    'hero.tabPartner': 'Partenaire',
    'hero.tabEnterprise': 'Entreprise',
    'hero.promptAgents': 'Ex. : Villas off-market pour mes clients à Marbella ou Dubaï…',
    'hero.promptBuy': 'Ex. : Maison 3 ch. près d\'écoles, moins de 800k € à Lisbonne…',
    'hero.promptRent': 'Ex. : 2 ch. meublé près du métro, bail long, max 2500 $/mois…',
    'hero.promptInvest': 'Ex. : Rendement locatif stable 7 %+, Europe ou EAU, ticket 500k €…',
    'hero.promptPartner': 'Ex. : Co-listing luxe front de mer avec acheteurs internationaux…',
    'hero.promptEnterprise': 'Ex. : Déploiement pour notre réseau d\'agences APAC et MENA…',
    'hero.numbersStripAria': 'Indicateurs clés',
    'hero.numbersSegmentLabel': 'Segments clients couverts',
    'hero.numbersSolutionsLabel': 'Solutions plateforme',
    'hero.numbersMarketsLabel': 'Marchés mondiaux',
    'hero.numbersAllValue': 'Tous',
    'journeyStrip.aria': 'Étapes du parcours immobilier',
    'journeyStrip.eyebrow': 'Un abonnement · Tout le parcours immobilier',
    'journeyStrip.headingLead': 'Chaque étape. Chaque acteur.',
    'journeyStrip.headingAccent': 'Une plateforme.',
    'journeyStrip.step1Title': 'Découverte',
    'journeyStrip.step1Desc': 'Trouvez des opportunités sur tous les marchés avec précision intelligente',
    'journeyStrip.step2Title': 'Intelligence marché',
    'journeyStrip.step2Desc': 'Évaluez valeur, demande et croissance avec des données réelles',
    'journeyStrip.step3Title': 'Matching d’opportunités',
    'journeyStrip.step3Desc': 'Connectez le bon acheteur, investisseur ou agent',
    'journeyStrip.step4Title': 'Collaboration transaction',
    'journeyStrip.step4Desc': 'Toutes les parties dans un espace partagé',
    'journeyStrip.step5Title': 'Gestion patrimoine',
    'journeyStrip.step5Desc': 'Annonces, actifs et documents sur une seule plateforme',
    'journeyStrip.step6Title': 'Insights portefeuille',
    'journeyStrip.step6Desc': 'Suivez la performance et la valeur long terme',
    'welcomeSection.aria': 'Bienvenue chez IPM',
    'welcomeSection.eyebrow': 'Bienvenue chez IPM',
    'welcomeSection.headingLead': 'Une référence historique,',
    'welcomeSection.headingAccent': 'réinventée.',
    'welcomeSection.body1': 'Alliant la précision des données à l’expérience humaine du secteur immobilier, IPM vous invite à une expérience connectée, intelligente et accessible partout dans le monde.',
    'welcomeSection.body2': 'Créée par des leaders immobiliers expérimentés, IPM a été pensée comme un écosystème intégré reliant insights, collaboration et portée mondiale sur une seule plateforme.',
    'welcomeSection.ctaExplore': 'Explorer la plateforme',
    'welcomeSection.ctaPricing': 'Voir les tarifs',
    'darkFeatureSection.aria': 'Solutions investisseur IPM et aperçu de la plateforme',
    'darkFeatureSection.investorTitle': 'IPM Investor',
    'darkFeatureSection.investorAccent': 'Solutions',
    'darkFeatureSection.searchPlaceholder': 'Décrivez votre prochain investissement idéal',
    'darkFeatureSection.rentalYieldTitle': 'Rendement locatif',
    'darkFeatureSection.rentalYieldSub': 'Estimation du rendement annuel',
    'darkFeatureSection.rentalYieldBadge': 'Au-dessus de la moyenne',
    'darkFeatureSection.domTitle': 'Jours sur le marché',
    'darkFeatureSection.domSub': 'Jours moyens avant vente',
    'darkFeatureSection.domBadge': 'Secteur dynamique',
    'darkFeatureSection.energyTitle': 'Performance énergétique',
    'darkFeatureSection.energySub': 'Performance énergétique du bâtiment',
    'darkFeatureSection.energyBadge': 'Performance de premier plan',
    'darkFeatureSection.confidenceTitle': 'Confiance investissement',
    'darkFeatureSection.confidenceSub': 'Score composite issu du marché, du loyer et de l’emplacement.',
    'darkFeatureSection.confidenceScore': 'Score de confiance',
    'darkFeatureSection.feat1Title': 'Forte demande expatriés',
    'darkFeatureSection.feat1Desc': 'Dubai Hills prisé des expatriés à revenus élevés et des télétravailleurs.',
    'darkFeatureSection.feat2Title': 'Neuf premium',
    'darkFeatureSection.feat2Desc': 'Livraison 2023 - pas de retard d’entretien, normes ESG modernes.',
    'darkFeatureSection.feat3Title': 'Plus-value régulière',
    'darkFeatureSection.feat3Desc': '+18 % sur 5 ans avec investissements d’infrastructure continus.',
    'darkFeatureSection.futureTitle': 'Perspectives',
    'darkFeatureSection.futureSub': 'Dans votre zone',
    'darkFeatureSection.propertyBlurb': 'Propriété contemporaine avec des prestations premium adaptées à votre portefeuille.',
    'darkFeatureSection.viewNow': 'Voir maintenant',
    'darkFeatureSection.ipmScore': 'IPM Score',
    'darkFeatureSection.pvScore': 'PV Score',
    'darkFeatureSection.scoreOutOf': '/ 100',
    'darkFeatureSection.barLeftAmount': '28 800 $',
    'darkFeatureSection.barRightAmount': '16 700 $',
    'darkFeatureSection.totalReturn': 'Rendement total',
    'darkFeatureSection.annualizedYtd': 'Annualisé (YTD)',
    'darkFeatureSection.returnGain': 'Gain estimé total : 24 500 $',
    'darkFeatureSection.capGrowth': 'Croissance du capital',
    'darkFeatureSection.netRental': 'Rendement locatif net',
    'darkFeatureSection.trajectory': 'Trajectoire annualisée et croissance du yield',
    'darkFeatureSection.months12': '12 mois',
    'darkFeatureSection.eyebrow': 'Exclusivité IPM',
    'darkFeatureSection.heading': 'Un abonnement. Tout le parcours immobilier.',
    'darkFeatureSection.headingLine1': 'Un abonnement.',
    'darkFeatureSection.headingLine2': 'Tout le parcours immobilier.',
    'darkFeatureSection.lead': 'IPM sert chaque acteur du cycle immobilier - des agents et agences qui remportent plus de mandats aux acheteurs qui trouvent le bon bien grâce à l’IA, en passant par les investisseurs qui modélisent le rendement en temps réel et les partenaires enterprise qui se déploient à l’échelle mondiale.',
    'darkFeatureSection.audience1Title': 'Agents & agences',
    'darkFeatureSection.audience1Body': 'Prospectez plus intelligemment, publiez plus vite et concluez en confiance. Scoring de leads IA, coût de lead 0 $, CMA Builder, home staging virtuel et CRM complet - tout pour gagner des mandats et développer votre activité.',
    'darkFeatureSection.audience2Title': 'Acheteurs, locataires & investisseurs',
    'darkFeatureSection.audience2Body': 'Trouvez le bon bien avec une recherche en langage naturel et un IPM Score sur chaque résultat. Modélisez le rendement locatif, analysez le marché et concluez sereinement avec Smart Vault AI qui relit chaque clause.',
    'darkFeatureSection.audience3Title': 'Partenaires enterprise & grands comptes',
    'darkFeatureSection.audience3Body': 'Connectez franchise, portefeuille corporate ou réseau de références à l’écosystème IPM. Outils white-label, espaces de collaboration transaction, portée mondiale et analytics enterprise au même endroit.',
    'darkFeatureSection.audience1ServicesCta': 'Découvrir les outils agents & agences →',
    'darkFeatureSection.audience2ServicesCta': 'Découvrir les outils acheteurs & locataires →',
    'darkFeatureSection.audience3ServicesCta': 'Découvrir les solutions enterprise & partenaires →',
    'darkFeatureSection.ctaPlatform': 'Explorer la plateforme complète',
    'darkFeatureSection.ctaPricing': 'Voir les tarifs',
    'serviceCardsSection.eyebrow': "À QUI S'ADRESSE",
    'serviceCardsSection.headingLine1': 'Votre parcours immobilier',
    'serviceCardsSection.headingLine2': 'vous appelle.',
    'serviceCardsSection.cta': 'Voir tous les services →',
    'hero.placeholder': 'Décrivez la propriété idéale...',
    'hero.feature1': 'IA hyper personnalisée pour vous',
    'hero.feature2': 'Analyses de marché et actualités',
    'hero.feature3': 'Une plateforme pour tous',
    'hero.stats1': 'Tâches automatisées pour les agents',
    'hero.stats2': 'Amélioration de la recherche immobilière',
    'hero.stats3': 'Rendements projetés sur les améliorations',
    'hero.slideBuyers': 'Acheteurs',
    'hero.slideInvestors': 'Investisseurs',
    'hero.slideSellers': 'Agences',
    'footer.getInTouch': 'Nous contacter',
    'footer.intro': 'Des questions ? Choisissez une date pour planifier un appel.',
    'footer.firstName': 'Prénom',
    'footer.lastName': 'Nom',
    'footer.email': 'E-mail',
    'footer.phone': 'Téléphone',
    'footer.helpPlaceholder': 'Comment pouvons-nous vous aider ?',
    'footer.submit': 'Envoyer',
    'common.loading': 'Chargement...',
    'common.view': 'Voir',
    'common.viewProperty': 'Voir le bien',
    'common.address': 'Adresse',
    'common.location': 'Lieu',
    'common.any': 'Tous',
    'common.bedrooms': 'Chambres',
    'common.resetAll': 'Réinitialiser',
    'common.clearFilters': 'Effacer les filtres',
    'common.pleaseLogin': 'Connectez-vous pour enregistrer.',
    'collection.resultsFor': 'Résultats pour',
    'collection.bestMatches': 'Nous avons trouvé les meilleures offres pour vous !',
    'collection.hideFilters': 'Masquer les filtres',
    'collection.specifyFilters': 'Plus de filtres',
    'collection.sortBy': 'Trier par',
    'collection.locations': 'Lieux',
    'collection.noPropertiesFound': 'Aucune propriété trouvée.',
    'collection.matchScoreLabel': 'Score',
    'saved.viewDetails': 'Voir les détails',
    'saved.noSavedYet': 'Aucune propriété enregistrée',
    'saved.browseCollection': 'Parcourir la collection',
    'saved.comingSoon': 'Consultez et gérez vos biens enregistrés en un seul endroit.',
    'saved.allTypes': 'Tous les types',
    'login.welcomeBack': 'Bon retour.',
    'login.welcomeSub': 'Vos performances, analyses et tendances du marché vous attendent.',
    'login.backToHome': 'Retour à l\'accueil',
    'login.logIn': 'Connexion',
    'login.enterCredentials': 'Entrez vos identifiants pour accéder au tableau de bord.',
    'login.emailAddress': 'Adresse e-mail',
    'login.password': 'Mot de passe',
    'login.forgot': 'Mot de passe oublié ?',
    'login.authenticating': 'Authentification...',
    'login.newToIpm': 'Nouveau sur IPM ?',
    'login.createAccount': 'Créer un compte',
    'sidebar.myDashboard': 'Mon tableau de bord',
    'sidebar.myPortfolio': 'Mon portefeuille',
    'sidebar.savedProperties': 'Biens enregistrés',
    'sidebar.listingManagement': 'Gestion des annonces',
    'sidebar.agents': 'Agents',
    'sidebar.myVault': 'Mon coffre',
    'sidebar.settings': 'Paramètres',
    'sidebar.addListing': 'Ajouter une annonce',
    'newDev.title': 'Nouveaux projets',
    'newDev.filterBy': 'Filtrer par',
    'newDev.country': 'Pays',
    'newDev.viewDevelopment': 'Voir le projet',
    'newDev.from': 'À partir de',
    'newDev.estimatedYield': 'Rendement estimé',
    'newDev.noDevelopments': 'Aucun projet dans',
    'listing.view': 'Aperçu',
    'listing.edit': 'Modifier',
    'listing.delete': 'Supprimer',
    'listing.priceActions': 'Prix + Actions',
    'listing.available': 'Disponible',
    'listing.featured': 'À la une',
    'listing.sold': 'Vendu',
    'listing.noListings': "Vous n'avez pas encore ajouté de propriété.",
    'sidebar.crm': 'CRM',
    'sidebar.marketing': 'Marketing',
    'sidebar.askAi': 'Demander à IPM IA',
    'about.title': 'À propos d\'IPM',
    'about.mission': 'Notre mission',
    'contact.getInTouch': 'Nous contacter',
    'contact.formIntro': 'Remplissez le formulaire et notre équipe vous répondra sous 24 h.',
    'contact.name': 'Nom',
    'contact.email': 'E-mail',
    'contact.message': 'Message',
    'contact.sendMessage': 'Envoyer le message',
    'news.loading': 'Chargement des articles...',
    'news.latestPosts': 'Derniers articles',
    'news.sortBy': 'Trier par',
    'news.minRead': 'min de lecture',
    'newsDetail.loading': 'Chargement de l\'article...',
    'newsDetail.notFound': 'Article introuvable.',
    'newsDetail.backToNews': '← Retour aux actualités',
  },
  ar: {
    'nav.home': 'الرئيسية',
    'nav.ipmNews': 'أخبار IPM',
    'nav.ipmAcademy': 'أكاديمية IPM',
    'nav.myIpmNews': 'أخباري IPM',
    'nav.newProperties': 'عقارات جديدة',
    'nav.logIn': 'تسجيل الدخول',
    'nav.signUp': 'إنشاء حساب',
    'nav.dashboard': 'لوحة التحكم',
    'nav.settings': 'الإعدادات',
    'nav.collection': 'المجموعة',
    'nav.logout': 'تسجيل الخروج',
    'nav.language': 'اللغة',
    'nav.currency': 'العملة',
    'nav.units': 'الوحدات',
    'nav.preferences': 'التفضيلات',
    'common.price': 'السعر',
    'common.area': 'المساحة',
    'common.sqft': 'قدم²',
    'common.sqm': 'م²',
    'common.beds': 'غرف',
    'common.baths': 'حمامات',
    'common.forSale': 'للبيع',
    'hero.search': 'ابحث حسب الموقع، نوع العقار...',
    'hero.find': 'اعثر على العقار المناسب',
    'collection.matchScore': 'التطابق',
    'collection.priceLow': 'السعر: منخفض',
    'collection.priceHigh': 'السعر: مرتفع',
    'collection.maxPrice': 'أقصى سعر',
    'collection.all': 'الكل',
    'saved.savedListings': 'المحفوظات',
    'saved.title': 'المجموعة المحفوظة',
    'saved.subtitle': 'إدارة الفرص المحفوظة',
    'property.estMonthly': 'التقدير الشهري',
    'property.bedsBaths': 'غرف، حمامات',
    'property.price': 'السعر',
    'property.area': 'المساحة',
    'footer.rights': 'جميع الحقوق محفوظة.',
    'hero.titleLine1': 'معيار جديد لعقارات',
    'hero.titleLine2': 'مدعومة بالذكاء',
    'hero.landingTitle1': 'سوق العقارات،',
    'hero.landingTitle2': 'بصورة جديدة.',
    'hero.landingTagline': 'منصة واحدة للوكلاء والمشترين والمستثمرين والشركاء - انتشار عالمي، بيانات حقيقية، وتعاون سلس.',
    'hero.searchCta': 'بحث',
    'hero.tabAgents': 'وكلاء',
    'hero.tabBuy': 'شراء',
    'hero.tabRent': 'إيجار',
    'hero.tabInvest': 'استثمار',
    'hero.tabPartner': 'شريك',
    'hero.tabEnterprise': 'مؤسسات',
    'hero.promptAgents': 'مثال: فيلات خارج السوق يناسبها عملائي في ماربيا أو دبي…',
    'hero.promptBuy': 'مثال: منزل 3 غرف قرب مدارس، أقل من 800 ألف يورو في لشبونة…',
    'hero.promptRent': 'مثال: شقتان مفروشتان قرب المترو، إيجار طويل، حتى 2500$/شهر…',
    'hero.promptInvest': 'مثال: عائد إيجاري ثابت 7%+، أوروبا أو الإمارات، 500 ألف يورو…',
    'hero.promptPartner': 'مثال: إدراج مشترك فاخر على الواجهة البحرية مع مشترين دوليين…',
    'hero.promptEnterprise': 'مثال: طرح لشبكة وكالاتنا في آسيا والشرق الأوسط…',
    'hero.numbersStripAria': 'مؤشرات المنصة',
    'hero.numbersSegmentLabel': 'شرائح العملاء المخدومة',
    'hero.numbersSolutionsLabel': 'حلول المنصة',
    'hero.numbersMarketsLabel': 'الأسواق العالمية',
    'hero.numbersAllValue': 'الكل',
    'journeyStrip.aria': 'مراحل الرحلة العقارية',
    'journeyStrip.eyebrow': 'اشتراك واحد · الرحلة العقارية كاملة',
    'journeyStrip.headingLead': 'كل مرحلة. كل طرف.',
    'journeyStrip.headingAccent': 'منصة واحدة.',
    'journeyStrip.step1Title': 'اكتشاف العقارات',
    'journeyStrip.step1Desc': 'اعثر على الفرص عبر الأسواق بدقة ذكية',
    'journeyStrip.step2Title': 'ذكاء السوق',
    'journeyStrip.step2Desc': 'قَيّم القيمة والطلب والنمو ببيانات حقيقية',
    'journeyStrip.step3Title': 'مواءمة الفرص',
    'journeyStrip.step3Desc': 'اربط المشتري أو المستثمر أو الوكيل المناسب',
    'journeyStrip.step4Title': 'تعاون الصفقة',
    'journeyStrip.step4Desc': 'جميع الأطراف في مساحة عمل مشتركة',
    'journeyStrip.step5Title': 'إدارة الأصول',
    'journeyStrip.step5Desc': 'القوائم والأصول والمستندات في منصة واحدة',
    'journeyStrip.step6Title': 'رؤى المحفظة',
    'journeyStrip.step6Desc': 'تتبع الأداء والقيمة على المدى الطويل',
    'welcomeSection.aria': 'مرحباً بك في IPM',
    'welcomeSection.eyebrow': 'مرحباً بك في IPM',
    'welcomeSection.headingLead': 'معيار تاريخي،',
    'welcomeSection.headingAccent': 'أعيد ابتكاره.',
    'welcomeSection.body1': 'يجمع IPM بين دقة البيانات والخبرة الإنسانية في القطاع العقاري ليدعوك إلى تجربة متصلة وذكية ومتاحة عالمياً.',
    'welcomeSection.body2': 'أسسه قادة عقاريون ذوو خبرة، وصُمم كمنظومة متكاملة تربط الرؤى والتعاون والانتشار العالمي في منصة واحدة.',
    'welcomeSection.ctaExplore': 'استكشف المنصة',
    'welcomeSection.ctaPricing': 'عرض الأسعار',
    'darkFeatureSection.aria': 'حلول المستثمرين ونظرة عامة على منصة IPM',
    'darkFeatureSection.investorTitle': 'IPM Investor',
    'darkFeatureSection.investorAccent': 'Solutions',
    'darkFeatureSection.searchPlaceholder': 'صف استثمارك المثالي القادم',
    'darkFeatureSection.rentalYieldTitle': 'عائد الإيجار',
    'darkFeatureSection.rentalYieldSub': 'تقدير العائد السنوي',
    'darkFeatureSection.rentalYieldBadge': 'فوق متوسط السوق',
    'darkFeatureSection.domTitle': 'أيام في السوق',
    'darkFeatureSection.domSub': 'متوسط الأيام قبل البيع',
    'darkFeatureSection.domBadge': 'منطقة حركة سريعة',
    'darkFeatureSection.energyTitle': 'تصنيف الطاقة',
    'darkFeatureSection.energySub': 'أداء الطاقة للمبنى',
    'darkFeatureSection.energyBadge': 'أداء من الدرجة الأولى',
    'darkFeatureSection.confidenceTitle': 'ثقة الاستثمار',
    'darkFeatureSection.confidenceSub': 'درجة مركبة من السوق والإيجار والموقع.',
    'darkFeatureSection.confidenceScore': 'درجة الثقة',
    'darkFeatureSection.feat1Title': 'طلب قوي من المغتربين',
    'darkFeatureSection.feat1Desc': 'دبي هيلز شائعة لدى المغتربين ذوي الدخل المرتفع والعاملين عن بُعد.',
    'darkFeatureSection.feat2Title': 'بناء جديد فاخر',
    'darkFeatureSection.feat2Desc': 'تسليم 2023 - بلا تراكم صيانة، مواصفات ESG حديثة.',
    'darkFeatureSection.feat3Title': 'ارتفاع مستمر في القيمة',
    'darkFeatureSection.feat3Desc': '+18٪ خلال 5 سنوات مع استثمار مستمر في البنية التحتية.',
    'darkFeatureSection.futureTitle': 'آفاق مستقبلية',
    'darkFeatureSection.futureSub': 'في منطقتك',
    'darkFeatureSection.propertyBlurb': 'عقار عصري بمزايا راقية تناسب محفظتك.',
    'darkFeatureSection.viewNow': 'عرض الآن',
    'darkFeatureSection.ipmScore': 'IPM Score',
    'darkFeatureSection.pvScore': 'PV Score',
    'darkFeatureSection.scoreOutOf': '/ 100',
    'darkFeatureSection.barLeftAmount': '€28,800',
    'darkFeatureSection.barRightAmount': '€16,700',
    'darkFeatureSection.totalReturn': 'إجمالي العائد',
    'darkFeatureSection.annualizedYtd': 'سنوي (منذ بداية العام)',
    'darkFeatureSection.returnGain': 'الربح التقديري الإجمالي: €24,500',
    'darkFeatureSection.capGrowth': 'نمو رأس المال',
    'darkFeatureSection.netRental': 'صافي عائد الإيجار',
    'darkFeatureSection.trajectory': 'مسار سنوي ونمو العائد',
    'darkFeatureSection.months12': '12 شهراً',
    'darkFeatureSection.eyebrow': 'حصري IPM',
    'darkFeatureSection.heading': 'اشتراك واحد. رحلة العقار بأكملها.',
    'darkFeatureSection.headingLine1': 'اشتراك واحد.',
    'darkFeatureSection.headingLine2': 'رحلة العقار بأكملها.',
    'darkFeatureSection.lead': 'تخدم IPM كل أطراف دورة العقار - من الوكلاء والوكالات الفائزة بمزيد من التفويضات، إلى المشترين الذين يجدون العقار المناسب بوضوح مدعوم بالذكاء الاصطناعي، والمستثمرين الذين يحسبون العائد لحظياً، وشركاء المؤسسات الذين ينمون عبر الأسواق العالمية.',
    'darkFeatureSection.audience1Title': 'الوكلاء والوكالات',
    'darkFeatureSection.audience1Body': 'استهدف بذكاء، اعرض أسرع، وأغلق بثقة. تقييم العملاء بالذكاء الاصطناعي، تكلفة عميل 0$، منشئ CMA، تجهيز افتراضي وCRM كامل - كل ما تحتاجه للفوز بالتفويضات وتنمية أعمالك.',
    'darkFeatureSection.audience2Title': 'المشترون والمستأجرون والمستثمرون',
    'darkFeatureSection.audience2Body': 'اعثر على العقار المناسب ببحث بلغة طبيعية ودرجة IPM Score على كل نتيجة. نمذجة عائد الإيجار، تحليل السوق، والإغلاق بثقة مع Smart Vault AI لمراجعة كل بند.',
    'darkFeatureSection.audience3Title': 'شركاء المؤسسات والشركات',
    'darkFeatureSection.audience3Body': 'اربط امتياز وكالتك أو المحفظة المؤسسية أو شبكة الإحالات بمنظومة IPM. أدوات بالعلامة البيضاء، مساحات تعاون للصفقات، انتشار عالمي وتحليلات مؤسسية في مكان واحد.',
    'darkFeatureSection.audience1ServicesCta': 'استكشف أدوات الوكلاء والوكالات ←',
    'darkFeatureSection.audience2ServicesCta': 'استكشف أدوات المشترين والمستأجرين ←',
    'darkFeatureSection.audience3ServicesCta': 'استكشف حلول المؤسسات والشركاء ←',
    'darkFeatureSection.ctaPlatform': 'استكشف المنصة كاملة',
    'darkFeatureSection.ctaPricing': 'عرض الأسعار',
    'serviceCardsSection.eyebrow': 'لمن',
    'serviceCardsSection.headingLine1': 'رحلتك العقارية',
    'serviceCardsSection.headingLine2': 'تناديك.',
    'serviceCardsSection.cta': 'عرض كل الخدمات ←',
    'hero.placeholder': 'صف العقار المثالي...',
    'hero.feature1': 'ذكاء اصطناعي مخصص لك',
    'hero.feature2': 'تحليلات السوق والأخبار المباشرة',
    'hero.feature3': 'منصة واحدة للجميع',
    'hero.stats1': 'مهام آلية للوكلاء',
    'hero.stats2': 'تحسن في أبحاث العقارات',
    'hero.stats3': 'عوائد متوقعة على التحسينات',
    'hero.slideBuyers': 'المشترون',
    'hero.slideInvestors': 'المستثمرون',
    'hero.slideSellers': 'الوكالات',
    'footer.getInTouch': 'تواصل معنا',
    'footer.intro': 'لديك أسئلة؟ اختر تاريخاً لجدولة مكالمة.',
    'footer.firstName': 'الاسم الأول',
    'footer.lastName': 'اسم العائلة',
    'footer.email': 'البريد الإلكتروني',
    'footer.phone': 'الهاتف',
    'footer.helpPlaceholder': 'كيف يمكننا مساعدتك؟',
    'footer.submit': 'إرسال',
    'common.loading': 'جاري التحميل...',
    'common.view': 'عرض',
    'common.viewProperty': 'عرض العقار',
    'common.address': 'العنوان',
    'common.location': 'الموقع',
    'common.any': 'أي',
    'common.bedrooms': 'غرف النوم',
    'common.resetAll': 'إعادة تعيين',
    'common.clearFilters': 'مسح الفلاتر',
    'common.pleaseLogin': 'سجّل الدخول للحفظ.',
    'collection.resultsFor': 'نتائج لـ',
    'collection.bestMatches': 'وجدنا أفضل التطابقات لك!',
    'collection.hideFilters': 'إخفاء الفلاتر',
    'collection.specifyFilters': 'المزيد من الفلاتر',
    'collection.sortBy': 'ترتيب حسب',
    'collection.locations': 'المواقع',
    'collection.noPropertiesFound': 'لم يتم العثور على عقارات.',
    'collection.matchScoreLabel': 'نسبة التطابق',
    'saved.viewDetails': 'عرض التفاصيل',
    'saved.noSavedYet': 'لا توجد عقارات محفوظة بعد',
    'saved.browseCollection': 'تصفح المجموعة',
    'saved.comingSoon': 'عرض وإدارة جميع عقاراتك المحفوظة في مكان واحد.',
    'saved.allTypes': 'جميع الأنواع',
    'login.welcomeBack': 'مرحباً بعودتك.',
    'login.welcomeSub': 'أداء محفظتك وتحليلات السوق في انتظارك.',
    'login.backToHome': 'العودة للرئيسية',
    'login.logIn': 'تسجيل الدخول',
    'login.enterCredentials': 'أدخل بياناتك للوصول إلى لوحة التحكم.',
    'login.emailAddress': 'البريد الإلكتروني',
    'login.password': 'كلمة المرور',
    'login.forgot': 'نسيت؟',
    'login.authenticating': 'جاري التحقق...',
    'login.newToIpm': 'جديد على IPM؟',
    'login.createAccount': 'إنشاء حساب',
    'sidebar.myDashboard': 'لوحة التحكم',
    'sidebar.myPortfolio': 'محفظتي',
    'sidebar.savedProperties': 'العقارات المحفوظة',
    'sidebar.listingManagement': 'إدارة القوائم',
    'sidebar.agents': 'الوكلاء',
    'sidebar.myVault': 'خزانتي',
    'sidebar.settings': 'الإعدادات',
    'sidebar.addListing': 'إضافة إعلان',
    'newDev.title': 'التطورات الجديدة',
    'newDev.filterBy': 'تصفية حسب',
    'newDev.country': 'البلد',
    'newDev.viewDevelopment': 'عرض التطوير',
    'newDev.from': 'من',
    'newDev.estimatedYield': 'العائد التقديري',
    'newDev.noDevelopments': 'لا توجد تطويرات في',
    'listing.view': 'معاينة',
    'listing.edit': 'تعديل',
    'listing.delete': 'حذف',
    'listing.priceActions': 'السعر + الإجراءات',
    'listing.available': 'متاح',
    'listing.featured': 'مميز',
    'listing.sold': 'مباع',
    'listing.noListings': 'لم تضف أي عقارات بعد.',
    'sidebar.crm': 'CRM',
    'sidebar.marketing': 'التسويق',
    'sidebar.askAi': 'اسأل IPM الذكاء الاصطناعي',
    'about.title': 'عن IPM',
    'about.mission': 'مهمتنا',
    'contact.getInTouch': 'تواصل معنا',
    'contact.formIntro': 'املأ النموذج وسيتواصل معك فريقنا خلال 24 ساعة.',
    'contact.name': 'الاسم',
    'contact.email': 'البريد الإلكتروني',
    'contact.message': 'الرسالة',
    'contact.sendMessage': 'إرسال الرسالة',
    'news.loading': 'جاري تحميل المقالات...',
    'news.latestPosts': 'أحدث المنشورات',
    'news.sortBy': 'ترتيب حسب',
    'news.minRead': 'دقائق قراءة',
    'newsDetail.loading': 'جاري تحميل المقال...',
    'newsDetail.notFound': 'المقال غير موجود.',
    'newsDetail.backToNews': '← العودة إلى الأخبار',
  },
};

export const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'pt', label: 'Português' },
  { value: 'it', label: 'Italiano' },
  { value: 'zh', label: '中文' },
  { value: 'ja', label: '日本語' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'ru', label: 'Русский' },
  { value: 'hi', label: 'हिन्दी' },
  { value: 'ar', label: 'العربية' },
];

export const countryCurrencyMap = {
  'South Africa': 'ZAR', 'United States': 'USD', 'United Kingdom': 'GBP',
  'United Arab Emirates': 'AED', 'Saudi Arabia': 'SAR', 'Canada': 'CAD',
  'Australia': 'AUD', 'Japan': 'JPY', 'China': 'CNY', 'India': 'INR',
  'Mexico': 'MXN', 'Brazil': 'BRL', 'Singapore': 'SGD', 'Hong Kong': 'HKD',
  'Switzerland': 'CHF',
  'Germany': 'EUR', 'France': 'EUR', 'Italy': 'EUR', 'Spain': 'EUR',
  'Netherlands': 'EUR', 'Belgium': 'EUR', 'Austria': 'EUR', 'Ireland': 'EUR',
  'Portugal': 'EUR', 'Greece': 'EUR', 'Finland': 'EUR', 'Luxembourg': 'EUR',
  'Cyprus': 'EUR', 'Malta': 'EUR', 'Estonia': 'EUR', 'Latvia': 'EUR',
  'Lithuania': 'EUR', 'Slovakia': 'EUR', 'Slovenia': 'EUR', 'Croatia': 'EUR',
  'Mauritius': 'USD', 'Kenya': 'USD', 'Nigeria': 'USD', 'Ghana': 'USD',
  'Thailand': 'USD', 'Indonesia': 'USD', 'Malaysia': 'USD', 'Vietnam': 'USD',
  'Philippines': 'USD', 'Turkey': 'USD', 'Egypt': 'USD', 'Morocco': 'USD',
  'New Zealand': 'AUD', 'Qatar': 'AED', 'Bahrain': 'AED', 'Oman': 'AED', 'Kuwait': 'AED',
};

export const getCurrencyForCountry = (country) => {
  if (!country) return 'USD';
  return countryCurrencyMap[country] || 'USD';
};

export const currencyOptions = [
  { value: 'USD', label: 'USD - US Dollar', symbol: '$' },
  { value: 'EUR', label: 'EUR - Euro', symbol: '€' },
  { value: 'GBP', label: 'GBP - British Pound', symbol: '£' },
  { value: 'CHF', label: 'CHF - Swiss Franc', symbol: 'CHF' },
  { value: 'AED', label: 'AED - UAE Dirham', symbol: 'د.إ' },
  { value: 'SAR', label: 'SAR - Saudi Riyal', symbol: '﷼' },
  { value: 'CAD', label: 'CAD - Canadian Dollar', symbol: 'C$' },
  { value: 'AUD', label: 'AUD - Australian Dollar', symbol: 'A$' },
  { value: 'JPY', label: 'JPY - Japanese Yen', symbol: '¥' },
  { value: 'CNY', label: 'CNY - Chinese Yuan', symbol: '¥' },
  { value: 'INR', label: 'INR - Indian Rupee', symbol: '₹' },
  { value: 'ZAR', label: 'ZAR - South African Rand', symbol: 'R' },
  { value: 'MXN', label: 'MXN - Mexican Peso', symbol: 'MX$' },
  { value: 'BRL', label: 'BRL - Brazilian Real', symbol: 'R$' },
  { value: 'SGD', label: 'SGD - Singapore Dollar', symbol: 'S$' },
  { value: 'HKD', label: 'HKD - Hong Kong Dollar', symbol: 'HK$' },
];

export const unitOptions = [
  { value: 'sqft', label: 'Square feet (sqft)' },
  { value: 'sqm', label: 'Square meters (m²)' },
];
